/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React from "react";

import { Fade } from "react-awesome-reveal";

import Button from "../elements/Button";

import BuildWebsite from "../assets/images/hero/BuildWebsite.png";

export default function Hero() {
  return (
    <section className="hero bg-cover bg-center min-h-screen relative" style={{ backgroundImage: `url(${BuildWebsite})` }}>
  <div className="absolute inset-0 bg-black/50 z-0" />
  <div className="relative z-10 w-full lg:w-3/4 xl:pl-12 sm:pr-2 mt-8">
        <h1 className="text-5xl sm:text-6xl text-white font-bold leading-tight mt-10 mb-5">
        Driven by Commitment, <br />
        Defined by Results
        </h1>

        <p className="font-light text-xl text-white leading-relaxed mb-16">
        Building Partnerships, Delivering Excellence: Committed to Crafting Success Together.
        </p>
        <Fade direction="up" delay={500} triggerOnce>
          <Button
            href="/service"
            type="link"
            className="flex w-71 h-18 items-center px-14 py-5 text-white text-xl bg-theme-purple rounded-lg shadow-2xl hover:bg-dark-theme-purple transition duration-200"
          >
            Know more
            <svg
              className="ml-2 w-7 h-7 text-white animate-bounce-x"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Button>
        </Fade>
      </div>
    </section>
  );
}
